var collapsibletoggles = document.querySelectorAll('[data-collapsible]');

function settogglesizes() {
    collapsibletoggles.forEach((item) => {
        let itemheight = item.querySelector('.text-base.w-full').offsetHeight;
        item.querySelector('[data-inner]').style.maxHeight = `${itemheight + 20}px`;
    }); 
}

collapsibletoggles.forEach((item) => {
    item.addEventListener('click', (event) => {
        let item = event.target;
        let plusbtn = item.querySelector('[data-toggle]');
        let plusbtnstatus = plusbtn.dataset.toggle;
        let iteminner = item.querySelector('[data-inner]');
        let parent = item.parentNode;

        parent.querySelectorAll('[data-collapsible]').forEach(async (item) => {
            item.querySelector('[data-toggle]').setAttribute('data-toggle', '');
            item.querySelector('[data-inner]').classList.add('!max-h-0');
        });

        if(plusbtnstatus == "open") {
            plusbtn.setAttribute('data-toggle', '');
            iteminner.classList.add('!max-h-0');
        }
        else {
            plusbtn.setAttribute('data-toggle', 'open');
            iteminner.classList.remove('!max-h-0');
        }
    });
});

window.addEventListener('resize', function(event) {
    settogglesizes();
}, true);

settogglesizes();